module.exports = __webpack_public_path__ + "img/5_heart.7f802a86.jpg";